import { ParPricingStep } from '../../../services/pricing';
import { PropElemStepRequest } from '../../../services/proposal';

export function pricingStepToElementStep(
  step: ParPricingStep[],
): PropElemStepRequest []{
  // SERV = serviceduration ==> ctecalculationtype
  // SERV = servicecalculationmethod ==> ctecalculationbasis
  // FIN = calculationmethod ==>ctecalculationtype

  //return (
    const list = step.map((e:ParPricingStep)=>{
      return {cteid:0,
      ctesamortizedcoef:e.ctesamortizedcoef,
      ctesduration: e.ctesduration,
      ctesid: e.ctesid,
      ctesorder:e.ctesorder,
      ctesperiodicity: e.ctesperiodicity,
      ctesperiodicityunit: e.ctesperiodicityunit,
      ctesrentalamount: e.ctesrentalamount,
      ctesrentalcoef: e.ctesrentalcoef,
      ctesoutstandingamount:e.ctesoutstandingamount,
      status:'INIT',
      ctrid: 0}
    });
     
    return list;
  //);
}

